module.exports = __webpack_public_path__ + "54eb8f56fdf083e756db4a6782e1d8d1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/reading/review-small.png
// module id = 187
// module chunks = 0